import { jsx as _jsx } from "react/jsx-runtime";
import { useTrackRender } from '#pplx/frontend/framework/templates/TemplateDebugContext.js';
import { templateEngineStore } from '#pplx/frontend/framework/templates/templateEngineStore.js';
import { memo, useCallback } from 'react';
import { useStore } from 'zustand';
import { useShallow } from 'zustand/react/shallow';
const EMPTY_PROPS = {};
/**
 * Renders a single portal container component for a slot.
 *
 * Memo'd to prevent re-renders from parent Layout re-renders.
 * Reads slot props via useShallow for referential stability.
 */
export const LayoutSlotContainerRenderer = memo(function LayoutSlotContainerRenderer({ templateName, slotName, SlotContainerComponent, }) {
    useTrackRender(`LayoutSlotContainerRenderer:${slotName}`);
    const containerRefCallback = useCallback((node) => {
        if (node) {
            templateEngineStore.getState().registerContainer(templateName, slotName, node);
        }
        else {
            templateEngineStore.getState().unregisterContainer(templateName, slotName);
        }
    }, [templateName, slotName]);
    const slotProps = useStore(templateEngineStore, useShallow((s) => s.templates.get(templateName)?.slotProps.get(slotName) ?? EMPTY_PROPS));
    return _jsx(SlotContainerComponent, { ref: containerRefCallback, ...slotProps });
});
//# sourceMappingURL=LayoutSlotContainerRenderer.js.map